module.exports = __webpack_public_path__ + "media/images/cplook/drag-handle-2813ab3ba1fbf1e93b6d0524ae9e5765.png";